import { Link } from '@interfaces/search';

export const getLinkText = (l: Link) => `${l.productionOrderNumber}-${l.productionOperationNumber}`;